export class TargetURL {
  get() {
    return process.env.REACT_APP_API
  }
  getCorresponsaliasURL() {
    return process.env.REACT_APP_CORRESPONSALIAS_API
  }
  setServices() {
    return process.env.REACT_APP_SERVICES
  }
}
